// assistantActions.ts
// Frontend-owned action types for the Vetsi assistant. Kept independent of the
// generated client's nested typing so the dispatcher stays robust; parse the raw
// `response.data.action` through parseAssistantAction before using it.
export type AssistantAction =
  | { type: 'fill_patient_notes'; payload: { notes: string } }
  | { type: 'fill_internal_notes'; payload: { notes: string } }
  | { type: 'fill_text_note'; payload: { notes: string } };

export function parseAssistantAction(raw: unknown): AssistantAction | null {
  if (!raw || typeof raw !== 'object') return null;
  const action = raw as { type?: unknown; payload?: unknown };
  if (
    action.type !== 'fill_patient_notes' &&
    action.type !== 'fill_internal_notes' &&
    action.type !== 'fill_text_note'
  ) {
    return null;
  }
  const payload = action.payload as { notes?: unknown } | undefined;
  if (!payload || typeof payload.notes !== 'string') return null;
  return { type: action.type, payload: { notes: payload.notes } };
}
